import InboomaBaseModel from './InboomaBaseModel';

export default InboomaBaseModel.extend({

    urlRoot : '/resources',

    defaults : {
      id : "",
      name : "",
      contingent_id : "",
      location_id : "",
      status : "active",
      longitude : "",
      latitude : "",
      secret : "",
      mac : "",
      created : "",
      modified : "",
      deleted : ""
    },

    _rbac : {
      "admin" : {
        "read" : true,
        "write" : true,
        "edit" : true,
        "edit-status" : true,
        "remove" : true
      },
      "user" : {
        "read" : true,
        "write" : false,
        "edit" : false,
        "edit-status" : false,
        "remove" : false,
      },
      "garage-staff" : {
        "read" : true,
        "write" : false,
        "edit" : false,
        "edit-status" : false,
        "remove" : false,
      },
      "manager" : {
        "read" : true,
        "write" : false,
        "edit" : true,
        "edit-status" : true,
        "remove" : false
      },
      "booking-manager" : {
        "read" : true,
        "write" : false,
        "edit" : true,
        "edit-status" : true,
        "remove" : false
      },
      "manager-location" : {
        "read" : true,
        "write" : false,
        "edit" : true,
        "edit-status" : true,
        "remove" : false
      }
    },

});